import {
  aSignal,
  aSumoSearchJobStatus,
  mockRecordSearchResultsForSignalOperationQuery,
} from '__generated__';
import { delay, HttpResponse } from 'msw';

export const handlers = [
  mockRecordSearchResultsForSignalOperationQuery(
    async ({ query: _query, variables: _variables }) => {
      await delay(1500);
      return HttpResponse.json({
        data: {
          __typename: 'Query',
          sumoRecordSearchJobStatus: aSumoSearchJobStatus(),
          sumoRecordSearchJobResults: [aSignal().allRecordsJson],
        },
      });
    }
  ),
];
